import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'

import {
  Flex,
  FlexItem,
  Title,
  Text,
  TEXT_VARIANT_LIGHT
} from 'mailup-web-components'
import IconTotalRecipients from 'Img/IconTotalRecipients'

import { sendingsState } from '../recoil/state/sendings'

const RecipientsStatus = () => {
  const intl = useIntl()
  const { dateFromFormatted, totalCount, totalSent } = useRecoilValue(
    sendingsState
  )

  return (
    <Flex alignItems='flex-start'>
      <FlexItem margin='0 8px 0 0'>
        <IconTotalRecipients />
      </FlexItem>
      <FlexItem margin='0 16px'>
        <Title>{intl.formatNumber(totalSent)}</Title>
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({
            id: 'Load.SmtpPlusV2SendQueue.SendedMessages'
          })}{' '}
          <strong>{dateFromFormatted}</strong>
        </Text>
      </FlexItem>
      <FlexItem margin='0 16px'>
        <Title>{intl.formatNumber(totalCount)}</Title>
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({
            id: 'Load.SmtpPlusV2SendQueue.QueuedMessages'
          })}
        </Text>
      </FlexItem>
    </Flex>
  )
}

export default RecipientsStatus
